import { PaginationResponse } from '@repo/ui/data-table'

import { AffectedStaffLight } from '../../lib/types/models/affectedStaff/affected-staff'
import { CenterRad } from '../../lib/types/models/center/center'
import { Rad } from '../../lib/types/models/rad/rad'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getRad(id: number) {
  return restApiClient.url(constructApiUrl(API.rads.get.url, { id })).get<Rad>()
}

export function getRadCenters(id: number) {
  return restApiClient
    .url(constructApiUrl(API.rads.getRadCenters.url, { id }))
    .get<PaginationResponse<CenterRad>>()
}

export function getRadParticipants(id: number) {
  return restApiClient
    .url(constructApiUrl(API.rads.getRadParticipants.url, { id }))
    .get<PaginationResponse<AffectedStaffLight>>()
}
